/**
 * useMediaQuery Hook - MA-ARCH-161
 * 
 * Generic media query hook for responsive breakpoints.
 * 
 * Usage:
 * const isDesktop = useMediaQuery('(min-width: 1024px)');
 * const isMobile = useMediaQuery('(max-width: 640px)');
 */

import { useState, useEffect } from 'react';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    try {
      return window.matchMedia(query).matches;
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      const mql = window.matchMedia(query);
      const handler = () => setMatches(mql.matches);
      handler();
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    } catch {
      // ignore
    }
  }, [query]);

  return matches;
}

// Convenience hooks for common breakpoints
export function useIsDesktop() {
  return useMediaQuery('(min-width: 1024px)');
}

export function useIsMobile() {
  return useMediaQuery('(max-width: 640px)');
}

export default useMediaQuery;
